import { StatusOptionType } from 'app/components/Engagements/EngagementsModals/UpdateEngagementStatusModal';
import {
  BotSchema,
  CampaignWorkflowSchema,
  DecoratedCrmIntegrationSchema,
  QualificationRuleItemSchema,
  TopicRuleName,
} from 'app/schemas';
import { AiToneInput } from 'app/schemas/aiTone';
import { AiWriterSchema } from 'app/schemas/aiWriter';
import {
  CustomIntentAction,
  CustomIntentBaseIntent,
  CustomIntentConversationStatus,
  CustomIntentSchema,
} from 'app/schemas/customIntent';
import { EmailGrade } from 'app/schemas/leadJourney';
import { DefaultIntentClassification } from 'app/schemas/playground';
import { capitalize, upperCase } from 'lodash';

export const COMPANY_NAME = '6sense';
export const SHORT_COMPANY_NAME = 'AI Email';
export const FULL_COMPANY_NAME = `${COMPANY_NAME} ${SHORT_COMPANY_NAME}`;

export const AI_INBOX_VIEW_PERMISSION_KEY = 'CE:AI_INBOX:VIEW';
export const AI_INBOX_EDIT_PERMISSION_KEY = 'CE:AI_INBOX:VIEW_EDIT';
export const AI_INBOX_PERMISSION_KEYS = [
  AI_INBOX_VIEW_PERMISSION_KEY,
  AI_INBOX_EDIT_PERMISSION_KEY,
];

export const INTEGRATIONS_VIEW_PERMISSION_KEY = 'CE:INTEGRATIONS:VIEW';
export const INTEGRATIONS_EDIT_PERMISSION_KEY = 'CE:INTEGRATIONS:VIEW_EDIT';
export const INTEGRATIONS_PERMISSION_KEYS = [
  INTEGRATIONS_VIEW_PERMISSION_KEY,
  INTEGRATIONS_EDIT_PERMISSION_KEY,
];

export const TEAM_VIEW_PERMISSION_KEY = 'CE:TEAM:VIEW';
export const TEAM_EDIT_PERMISSION_KEY = 'CE:TEAM:VIEW_EDIT';
export const TEAM_PERMISSION_KEYS = [TEAM_VIEW_PERMISSION_KEY, TEAM_EDIT_PERMISSION_KEY];

export const CAMPAIGNS_VIEW_PERMISSION_KEY = 'CE:CAMPAIGNS:VIEW';
export const CAMPAIGNS_EDIT_PERMISSION_KEY = 'CE:CAMPAIGNS:VIEW_EDIT';
export const CAMPAIGNS_PERMISSION_KEYS = [
  CAMPAIGNS_VIEW_PERMISSION_KEY,
  CAMPAIGNS_EDIT_PERMISSION_KEY,
];

export const PEOPLE_VIEW_PERMISSION_KEY = 'CE:PEOPLE:VIEW';
export const PEOPLE_EDIT_PERMISSION_KEY = 'CE:PEOPLE:VIEW_EDIT';
export const PEOPLE_PERMISSION_KEYS = [PEOPLE_VIEW_PERMISSION_KEY, PEOPLE_EDIT_PERMISSION_KEY];

export const AUTOMATION_RULES_VIEW_PERMISSION_KEY = 'CE:AUTOMATION_RULES:VIEW';
export const AUTOMATION_RULES_EDIT_PERMISSION_KEY = 'CE:AUTOMATION_RULES:VIEW_EDIT';
export const AUTOMATION_RULES_PERMISSION_KEYS = [
  AUTOMATION_RULES_VIEW_PERMISSION_KEY,
  AUTOMATION_RULES_EDIT_PERMISSION_KEY,
];

export const CONVERSATIONS_VIEW_PERMISSION_KEY = 'CE:CONVERSATIONS:VIEW';
export const CONVERSATIONS_EDIT_PERMISSION_KEY = 'CE:CONVERSATIONS:VIEW_EDIT';
export const CONVERSATIONS_PERMISSION_KEYS = [
  CONVERSATIONS_VIEW_PERMISSION_KEY,
  CONVERSATIONS_EDIT_PERMISSION_KEY,
];

export const INSIGHTS_VIEW_PERMISSION_KEY = 'CE:INSIGHTS:VIEW';
export const INSIGHTS_PERMISSION_KEYS = [INSIGHTS_VIEW_PERMISSION_KEY];

export const HUMAN_REVIEW_VIEW_PERMISSION_KEY = 'CE:HUMAN_REVIEW:VIEW';
export const HUMAN_REVIEW_EDIT_PERMISSION_KEY = 'CE:HUMAN_REVIEW:VIEW_EDIT';
export const HUMAN_REVIEW_PERMISSION_KEYS = [
  HUMAN_REVIEW_VIEW_PERMISSION_KEY,
  HUMAN_REVIEW_EDIT_PERMISSION_KEY,
];

export const HUMAN_REVIEW_CONFIG_VIEW_PERMISSION_KEY = 'CE:HUMAN_REVIEW_CONFIG:VIEW';
export const HUMAN_REVIEW_CONFIG_EDIT_PERMISSION_KEY = 'CE:HUMAN_REVIEW_CONFIG:VIEW_EDIT';
export const HUMAN_REVIEW_CONFIG_PERMISSION_KEYS = [
  HUMAN_REVIEW_CONFIG_VIEW_PERMISSION_KEY,
  HUMAN_REVIEW_CONFIG_EDIT_PERMISSION_KEY,
];

export const DOMAINS_VIEW_PERMISSION_KEY = 'CE:DOMAINS:VIEW';
export const DOMAINS_EDIT_PERMISSION_KEY = 'CE:DOMAINS:VIEW_EDIT';
export const DOMAINS_PERMISSION_KEYS = [DOMAINS_VIEW_PERMISSION_KEY, DOMAINS_EDIT_PERMISSION_KEY];

export const SALES_TEAM_VIEW_PERMISSION_KEY = 'CE:SALES_TEAM:VIEW';
export const SALES_TEAM_EDIT_PERMISSION_KEY = 'CE:SALES_TEAM:VIEW_EDIT';
export const SALES_TEAM_PERMISSION_KEYS = [
  SALES_TEAM_VIEW_PERMISSION_KEY,
  SALES_TEAM_EDIT_PERMISSION_KEY,
];

export const CUSTOM_FIELDS_VIEW_PERMISSION_KEY = 'CE:CUSTOM_FIELDS:VIEW';
export const CUSTOM_FIELDS_EDIT_PERMISSION_KEY = 'CE:CUSTOM_FIELDS:VIEW_EDIT';
export const CUSTOM_FIELDS_PERMISSION_KEYS = [
  CUSTOM_FIELDS_VIEW_PERMISSION_KEY,
  CUSTOM_FIELDS_EDIT_PERMISSION_KEY,
];

export const AI_INPUTS_VIEW_PERMISSION_KEY = 'CE:AI_INPUTS:VIEW';
export const AI_INPUTS_EDIT_PERMISSION_KEY = 'CE:AI_INPUTS:VIEW_EDIT';
export const AI_INPUTS_PERMISSION_KEYS = [
  AI_INPUTS_VIEW_PERMISSION_KEY,
  AI_INPUTS_EDIT_PERMISSION_KEY,
];

export const NOTIFICATIONS_VIEW_PERMISSION_KEY = 'CE:NOTIFICATIONS:VIEW';
export const NOTIFICATIONS_EDIT_PERMISSION_KEY = 'CE:NOTIFICATIONS:VIEW_EDIT';
export const NOTIFICATIONS_PERMISSION_KEYS = [
  NOTIFICATIONS_VIEW_PERMISSION_KEY,
  NOTIFICATIONS_EDIT_PERMISSION_KEY,
];

export const DAYS_OF_WEEK = [
  { dayOfWeek: 'mon', dayOfWeekDisplayText: 'Monday' },
  { dayOfWeek: 'tue', dayOfWeekDisplayText: 'Tuesday' },
  { dayOfWeek: 'wed', dayOfWeekDisplayText: 'Wednesday' },
  { dayOfWeek: 'thu', dayOfWeekDisplayText: 'Thursday' },
  { dayOfWeek: 'fri', dayOfWeekDisplayText: 'Friday' },
  { dayOfWeek: 'sat', dayOfWeekDisplayText: 'Saturday' },
  { dayOfWeek: 'sun', dayOfWeekDisplayText: 'Sunday' },
];
export const DEFAULT_WH_START_TIME = '08:00';
export const DEFAULT_WH_END_TIME = '17:00';

export const DEFAULT_INBOX_WARMUP_DAILY_LIMIT = {
  dormant: 20,
  active: 100,
  healthy: 200,
};

export const DAILY_LIMIT_AT_RISK = 200;
export const BOUNCE_RATE_AT_RISK = 5;

export const BOT_LABEL = 'email agent';
export const FULL_BOT_LABEL = 'AI Email Agent';
const LEAD_LABEL = 'contact';
export function leadLabel({
  plural = false,
  capitalized = false,
  upCase = false,
}: {
  capitalized?: boolean;
  plural?: boolean;
  upCase?: boolean;
} = {}) {
  const label = LEAD_LABEL;
  if (plural) {
    return upCase ? `${upperCase(label)}S` : capitalized ? `${capitalize(label)}s` : `${label}s`;
  } else {
    return upCase ? upperCase(label) : capitalized ? capitalize(label) : label;
  }
}

export const UPDATABLE_TERMINAL_OPTIONS = [
  'not_interested',
  'not_interested_now',
  'qualified',
  'bounced',
  'canceled',
];
export const TERMINAL_ENGAGEMENT_STATUS_OPTIONS = [
  {
    text: 'Not interested',
    value: 'not_interested',
    classificationValue: 'negative_intent' as const,
  },
  {
    text: 'Not interested now',
    value: 'not_interested_now',
    classificationValue: 'not_interested_now' as const,
  },
  {
    text: 'Qualified',
    value: 'qualified',
    classificationValue: 'qualified_positive_intent_(goal_conversion)' as const,
  },
];
export const ENGAGEMENT_STATUS_OPTIONS: StatusOptionType[] = TERMINAL_ENGAGEMENT_STATUS_OPTIONS.map(
  ({ value, text, classificationValue }, key) => ({
    key,
    value,
    text,
    content: text,
    classificationValue,
  })
);

// used by the API to signify eternal dates or something
export const SPECIAL_START_DATE = '0001-01-01T00:00:00.000Z';
export const SPECIAL_END_DATE = '3000-01-01T00:00:00.000Z';

export const MAX_TOTAL_ATTACHMENTS_SIZE = 5000000;
export const LEAD_IMPORT_LABELS: { [key: string]: any } = {
  noLeadOwner: `No ${LEAD_LABEL} owner`,
  duplicateRow: 'Rows with duplicate',
  invalidLeadOwner: `Owner not in ${COMPANY_NAME}`,
  noAccountName: 'No account name',
  invalidEmail: 'Invalid email',
  missingFirstName: 'No first name',
  invalidFirstName: 'Improper first name',
  existingEmail: `Email exists in ${COMPANY_NAME}`,
  existingCrmObject: `CRM object ID exists in ${COMPANY_NAME}`,
  exceedLeadImportCount: 'Exceeds import limit',
  existingEmailFromDiffCrmObject: `Email linked to other CRM leads`,
  existingIntegrationLeadWithDiffEmail: `Emails in CRM and ${SHORT_COMPANY_NAME} don’t match`,
  invalidLeadOwnerEmail: `Invalid lead owner email`,
  emailDomainSharedWithBot: `Same email domain as ${FULL_BOT_LABEL}`,
  emailSharedWithSalesRep: 'Same email as a sales rep',
  invalidCrmDetails: 'Invalid CRM details',
};

export const SALES_REP_IMPORT_LABELS: { [key: string]: string } = {
  missingLastName: 'No last name',
  missingCalendarLinkAndText: 'No calendar info',
  missingFirstName: 'No first name',
  invalidFirstName: 'Invalid first name',
  invalidLastName: 'Invalid last name',
  duplicateRow: 'Sales reps with same email',
  invalidEmail: 'Invalid or no email',
  invalidCalendarLinkText: 'Invalid or no calendar text',
  invalidCalendarLink: 'Invalid or no calendar link',
};

/** CAMPAIGN_NAME_ERROR - Specific error message we expect for duplicate name error */
export const CAMPAIGN_NAME_ERROR = 'Name has already been taken';

export const PERSISTED_OPTIONS = ['fill_blank_values', 'overwrite', 'skip_existing_leads'];
export const PERSISTED_OPTIONS_LABELS = {
  fill_blank_values: 'Update missing fields',
  overwrite: 'Overwrite existing fields',
  skip_existing_leads: `Don’t import duplicated ${leadLabel({ plural: true })}`,
};

export const DUPLICATE_SALES_REP_OPTIONS = [
  {
    label: 'Update empty fields with file data',
    value: 'fill_blank_values',
  },
  {
    label: 'Overwrite existing fields with file data',
    value: 'overwrite',
  },
  {
    label: 'Ignore file data',
    value: 'skip_existing_sales_reps',
  },
];

export const NO_CONTROLS_ROUTES: { [key: string]: any } = {
  'campaign_launcher/details/preview': true,
  'campaigns/preview': true,
  'oauth2/gmail/callback': true,
  'oauth2/outlook/callback': true,
  assign_human_review_task: true,
  cancel_human_review_task: true,
  confirmation_email_sent: true,
  continue_human_review_task: true,
  conversation_flow: true,
  email_confirmation: true,
  hello: true,
  integration_reconnected: true,
  reset_password: true,
  set_password: true,
  lexical_playground: true,
  update_human_review_task: true,
};
export const EXCLUDED_TOPIC_RULES = [1, 2, 3, 433, 434, 435]; // apparently required for ancient magic. possibly not needed anymore
/**
 * Aside from custom rules, we also want to filter out deprecated standard topic rules.
 * Since these topic rules aren't consistent across environments, we can't rely on ids and have to filter through string matching
 */
export const DEPRECATED_TOPIC_RULES = [
  'Request For Information (Pricing)',
  'Using Other Solution',
  'Not The Right Person',
  'Not A Good Time',
];
export const PER_PAGE = 10;
export const TEXT_LIMIT = 1000;
export const TEAM_CONTENT_SAMPLES_LIMIT = 20;
export const CAMPAIGN_CONTENT_SAMPLES_FOR_TONE_LIMIT = 10;
export const FOLLOW_UP_EMAIL_TRIGGER_DURATION = 3;

export const REVIEW_ENROLLMENT_LABELS: { [key: string]: any } = {
  missingMergeTags: 'No merge tags',
  doNotContact: 'Marked as Do Not Contact',
  inCurrentCampaign: 'Already enrolled in this campaign',
  inCurrentTopic: 'Already enrolled in this topic',
  missingMergeTagsWithoutFallback: 'No merge tags or fallback',
  ongoingEngagement: 'Already in ongoing conversation',
  inSuppressionLists: 'Part of suppression list',
  pausedCampaign: 'Campaign is paused',
  roleBasedEmail: 'Role-based email addresses',
  invalidEmailServer: 'Invalid email server',
  freeEmailProvider: 'Personal email addresses',
  disposableEmail: 'Disposable email addresses',
  internalBounceChecks: 'Potential bounce risk',
};

export const ACCOUNT_SOURCE_LABELS = [
  // used for accounts table and accountDetailsContainer
  { source: 'app', label: COMPANY_NAME, icon: 'SixSenseLogo' },
  { source: 'hubspot', label: 'HubSpot', icon: 'integration-hubspot' },
  { source: 'salesforce', label: 'Salesforce', icon: 'integration-salesforce' },
  { source: 'spreadsheet', label: 'CSV', icon: '' },
  { source: 'zapier', label: 'Zapier', icon: 'Zapier' },
  { source: 'api', label: 'API', icon: '' },
];

export const RESOURCE_TYPE_LABELS = {
  lead: LEAD_LABEL,
  engagement: 'conversations',
};

export const emptyMeta = {
  currentPage: 1,
  nextPage: null,
  prevPage: null,
  totalPages: 1,
  totalCount: 0,
};

export interface DropdownOptionsSchema {
  key: string;
  text: string;
  value: string | null;
}
export const MEMBER_TITLE_OPTIONS: DropdownOptionsSchema[] = [
  { text: 'Marketing', key: 'marketing', value: 'marketing' },
  { text: 'Sales', key: 'sales', value: 'sales' },
  { text: 'Operations', key: 'operations', value: 'operations' },
  { text: 'Founder', key: 'founder', value: 'founder' },
  { text: 'Company Management', key: 'company_management', value: 'company_management' },
  { text: 'Student Recruitment', key: 'student_recruitment', value: 'student_recruitment' },
  { text: 'Consultant/Professional services', key: 'consultant', value: 'consultant' },
  { text: 'IT services', key: 'it_services', value: 'it_services' },
  { text: 'Others', key: 'others', value: 'others' },
];

export const HOMEPAGE_RESOURCE_LIST = [
  {
    titleText: `${FULL_COMPANY_NAME} training flow`,
    descriptionText: 'Overview of the training flow and resources available.',
    redirectUrl: 'https://learn.6sense.com/6sense-conversational-email/1386428',
  },
  {
    titleText: 'Admin setup guide',
    descriptionText: `A one-page guide to the set up required prior to using ${FULL_COMPANY_NAME}.`,
    redirectUrl: 'https://learn.6sense.com/6sense-conversational-email/1382942',
  },
  {
    titleText: `${FULL_COMPANY_NAME} diagram`,
    descriptionText:
      'An overview of the steps needed from admin setup to reviewing campaign results.',
    redirectUrl: 'https://learn.6sense.com/6sense-conversational-email/1382852',
  },
  {
    titleText: '6sense Academy',
    descriptionText: `Visit our 6sense Academy page to learn more about ${FULL_COMPANY_NAME} and its features.`,
    redirectUrl: 'https://learn.6sense.com/6sense-conversational-email',
  },
  {
    titleText: `${FULL_COMPANY_NAME} support`,
    descriptionText: `Visit our support page to get answers and advice from the ${FULL_COMPANY_NAME} team for all our features.`,
    redirectUrl: 'https://support.6sense.com/',
  },
];

/**
 * copies for mapping types to file upload component
 */
export const ALL_UPLOAD_TYPE = {
  fileDescription: '',
  fileAccept:
    'application/pdf, image/*, application/zip, application/octet-stream, text/plain, .csv, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document',
};
export const CSV_DOC_UPLOAD_TYPE = {
  fileDescription: 'Supported file formats: CSV',
  fileAccept: '.csv, application/xls, application/octet-stream, text/csv',
};
export const TXT_DOC_UPLOAD_TYPE = {
  fileDescription: 'Supported file formats: PDF, DOCX, DOC, or TXT',
  fileAccept: '.pdf, .doc, .docx, .txt',
};
export const IMG_PDF_UPLOAD_TYPE = {
  fileDescription: 'Supported file formats: PDF, GIF, JPG, PNG',
  fileAccept: '.pdf, .gif, .jpg, .png, .svg',
};

export const IMG_UPLOAD_TYPE = {
  fileDescription: 'Supported file formats: GIF, JPG, PNG',
  fileAccept: '.gif, .jpg, .png, .svg',
};

/**
 * Used for mapping icons to file types
 */
export const DOC_TYPES = ['csv', 'doc', 'key', 'mdb', 'num', 'page', 'pdf', 'ppt', 'txt', 'xls'];
export const IMAGE_TYPES = ['gif', 'jpg', 'png', 'svg'];
export const MISC_TYPES = ['zip', 'file'];

export const CLOSING_DIV_TAG_LENGTH = 6;

export const DOMAIN_LIMIT = 10;

export const PLAYGROUND_EMAIL_IGNORE_MESSAGE = 'User has chosen to ignore email';

export type AiWriterWelcomeOnboardingVideo = { id: string; title: string };
export const AI_WRITER_WELCOME_ONBOARDING_VIDEOS: AiWriterWelcomeOnboardingVideo[] = [
  {
    id: 'ebai26ztx6',
    title: 'Getting Started',
  },
  {
    id: 'u2rrnpmge8',
    title: 'Editing and Using Emails',
  },
];
export const INTENT_CLASSIFICATIONS = {
  positive_intent: {
    label: 'Contact is Interested',
    description: 'Contact shows an interest in the offering.',
  },
  'qualified_positive_intent_(goal_conversion)': {
    label: 'Contact is Interested',
    description: 'Contact shows an interest in the offering.',
  },
  qualified: {
    label: 'Contact is Interested',
    description: 'Contact shows an interest in the offering.',
  },
  negative_intent: {
    label: 'Contact is Not Interested',
    description: 'Contact is not interested in the offering.',
  },
  not_interested: {
    label: 'Contact is Not Interested',
    description: 'Contact is not interested in the offering.',
  },
  not_interested_now: {
    label: 'Contact is Not Interested Now',
    description:
      'Contact is not interested specifically at this point of time, but might be in the future.',
  },
  'request_for_information_(generic)': {
    label: 'Contact Requests for Information',
    description: 'Contact requests for more information about the offering or company.',
  },
  dnc: {
    label: 'Do Not Contact',
    description: 'Contact wants to be removed from the mailing list.',
  },
  not_the_right_person: {
    label: 'Not the Right Person',
    description: 'Contact is not a decision maker or in the relevant department.',
  },
  referral: {
    label: 'Referral',
    description: 'Contact refers another person or department.',
  },
  out_of_office: {
    label: 'Out of Office',
    description: 'Contact mentions that they are currently on leave.',
  },
  bounced: {
    label: 'Bounced',
    description: 'Contact has left the company or email address is no longer in use.',
  },
  neutral_intent: {
    label: 'Neutral Intent',
    description:
      'Emails that have no clear expression of intent e.g., gibberish, automated response emails.',
  },
  unknown_intent: {
    label: 'Unknown Intent',
    description: 'The intent is unclear or there are mixed intents.',
  },
} as const;

export const CAMPAIGN_PRIORITY = { high: 9, low: 0 };

export const TRAINING_CONTENT_CONTENT_TYPE_OPTIONS = [
  'Case study',
  'One pager',
  'Product overview',
  'Blog post',
  'Email',
  'Battlecard',
  'White paper',
  'Others',
];

export const ROLE_LABELS = {
  admin: 'Administrator',
  member: 'Marketing User',
  view_only_admin: 'View Only User',
};

export const MAX_NUM_OF_TRAINING_CONTENTS = 20;
export const MAX_NUM_OF_SELECTED_TRAINING_CONTENTS = 5;

export const CUSTOM_INTENTS: CustomIntentSchema[] = [
  {
    name: 'Is already an Airtable customer.',
    description: 'This outlines a strategy to upsell to leads ... for our product.',
    replyStrategy: 'some talking point',
    callToAction: 'cc_sales_rep',
    baseIntent: null,
    actions: [],
  },
  {
    name: 'Moved away from Airtable.',
    description: 'This outlines a strategy to potentially rescue ... rescue the deal.',
    replyStrategy: 'some talking point',
    callToAction: 'continue_conversation',
    baseIntent: null,
    actions: [],
  },
];

export const AI_REPLIES_PREVIEW_SCENARIO = {
  [TopicRuleName.QUALIFIED]: `I am interested in scheduling a call. When are you available?`,
  [TopicRuleName.NOT_INTERESTED]: `Thank you, but we're not interested in this.`,
  [TopicRuleName.NOT_INTERESTED_NOW]: `This isn't a priority for us right now, but we might consider it in the future.`,
  [TopicRuleName.NOT_RIGHT_PERSON]: `I'm not the right person for this.`,
  [TopicRuleName.REFERRAL]: `Let me connect you with my colleague that handles this.`,
};

// used to render the intents when AI powered replies is turned on. hardcoding this for now temporarily, but eventually we'll move to a rendering two separate trees.
export const AI_INTENTS = [
  {
    id: 97311,
    teamId: 1,
    updatedAt: '2024-01-22T05:49:31.694Z',
    qualificationRuleId: 33667,
    topicRule: {
      id: 1,
      teamId: null,
      ruleType: 'standard',
      nextState: 'qualified',
      name: TopicRuleName.QUALIFIED,
      displayName: 'Contact is qualified',
      description: '',
      selectable: false,
    },
    sequence: {
      id: 108033,
      teamId: 1,
      isValid: true,
      conversationTopicVersionId: 10344,
      conversationTopicVersionSettings: {},
      conversationTopicId: 5962,
      terminalState: 'qualified',
      snippets: {
        referralOptIn:
          'Hi <snippet-merge-tag>{{original_lead.first_name}}</snippet-merge-tag>,<br><br>Thanks for connecting us. Greatly appreciate it!<br><br>',
        referralOptOut:
          'Hi <snippet-merge-tag>{{original_lead.first_name}}</snippet-merge-tag>,<br><br>Thanks for connecting us. Greatly appreciate it! Moving you to BCC to avoid spamming your inbox.<br><br>',
      },
      hasReferralSnippets: true,
      createdAt: '2024-01-22T05:49:31.630Z',
      nextState: 'qualified',
      displayName: 'Contact is qualified',
      highlightedAt: '2024-01-22T05:49:31.660Z',
      isRoot: false,
      topicRuleId: 1,
      sequenceTouchPoints: [],
      qualificationRule: null,
      didUpdate: false,
      shouldHighlight: false,
      isContinue: false,
      isReferral: false,
      isQualified: true,
      isNotInterested: false,
      isNotInterestedNow: false,
      isTerminal: true,
      isNotTerminal: false,
      hasChildren: false,
      hasFollowUpEmail: false,
    },
  },
  {
    id: 97312,
    teamId: 1,
    updatedAt: '2024-01-22T05:49:31.762Z',
    qualificationRuleId: 33667,
    topicRule: {
      id: 2,
      teamId: null,
      ruleType: 'standard',
      nextState: 'not_interested',
      name: TopicRuleName.NOT_INTERESTED,
      displayName: 'Contact is not interested',
      description: '',
      selectable: false,
    },
    sequence: {
      id: 108034,
      teamId: 1,
      isValid: true,
      conversationTopicVersionId: 10344,
      conversationTopicVersionSettings: {},
      conversationTopicId: 5962,
      terminalState: 'not_interested',
      snippets: {
        referralOptIn:
          'Hi <snippet-merge-tag>{{original_lead.first_name}}</snippet-merge-tag>,<br><br>Thanks for connecting us. Greatly appreciate it!<br><br>',
        referralOptOut:
          'Hi <snippet-merge-tag>{{original_lead.first_name}}</snippet-merge-tag>,<br><br>Thanks for connecting us. Greatly appreciate it! Moving you to BCC to avoid spamming your inbox.<br><br>',
      },
      hasReferralSnippets: true,
      createdAt: '2024-01-22T05:49:31.714Z',
      nextState: 'not_interested',
      displayName: 'Contact is not interested',
      highlightedAt: '2024-01-22T05:49:31.736Z',
      isRoot: false,
      topicRuleId: 2,
      sequenceTouchPoints: [],
      qualificationRule: null,
      didUpdate: false,
      shouldHighlight: false,
      isContinue: false,
      isReferral: false,
      isQualified: false,
      isNotInterested: true,
      isNotInterestedNow: false,
      isTerminal: true,
      isNotTerminal: false,
      hasChildren: false,
      hasFollowUpEmail: false,
    },
  },
  {
    id: 97313,
    teamId: 1,
    updatedAt: '2024-01-22T05:49:31.886Z',
    qualificationRuleId: 33667,
    topicRule: {
      id: 46,
      teamId: null,
      ruleType: 'standard',
      nextState: 'not_interested_now',
      name: TopicRuleName.NOT_INTERESTED_NOW,
      displayName: 'Contact is not interested now',
      description:
        'Your contact is not interested now but is open for re-engagement in the future.',
      selectable: false,
    },
    sequence: {
      id: 108035,
      teamId: 1,
      isValid: true,
      conversationTopicVersionId: 10344,
      conversationTopicVersionSettings: {},
      conversationTopicId: 5962,
      terminalState: 'not_interested_now',
      snippets: {
        referralOptIn:
          'Hi <snippet-merge-tag>{{original_lead.first_name}}</snippet-merge-tag>,<br><br>Thanks for connecting us. Greatly appreciate it!<br><br>',
        referralOptOut:
          'Hi <snippet-merge-tag>{{original_lead.first_name}}</snippet-merge-tag>,<br><br>Thanks for connecting us. Greatly appreciate it! Moving you to BCC to avoid spamming your inbox.<br><br>',
      },
      hasReferralSnippets: true,
      createdAt: '2024-01-22T05:49:31.773Z',
      nextState: 'not_interested_now',
      displayName: 'Contact is not interested now',
      highlightedAt: '2024-01-22T05:49:31.871Z',
      isRoot: false,
      topicRuleId: 46,
      sequenceTouchPoints: [],
      qualificationRule: null,
      didUpdate: false,
      shouldHighlight: false,
      isContinue: false,
      isReferral: false,
      isQualified: false,
      isNotInterested: false,
      isNotInterestedNow: true,
      isTerminal: true,
      isNotTerminal: false,
      hasChildren: false,
      hasFollowUpEmail: false,
    },
  },
  {
    id: 97317,
    teamId: 1,
    updatedAt: '2024-01-22T05:49:32.073Z',
    qualificationRuleId: 33667,
    topicRule: {
      id: 38,
      teamId: null,
      ruleType: 'standard',
      nextState: 'continue',
      name: TopicRuleName.NOT_RIGHT_PERSON,
      displayName: 'Not the right person',
      description:
        'Your contact mentions they are not the right person without referring another person contact.',
      selectable: true,
    },
    sequence: {
      id: 108036,
      teamId: 1,
      isValid: true,
      conversationTopicVersionId: 10344,
      conversationTopicVersionSettings: {},
      conversationTopicId: 5962,
      terminalState: 'continue',
      snippets: {
        referralOptIn:
          'Hi <snippet-merge-tag>{{original_lead.first_name}}</snippet-merge-tag>,<br><br>Thanks for connecting us. Greatly appreciate it!<br><br>',
        referralOptOut:
          'Hi <snippet-merge-tag>{{original_lead.first_name}}</snippet-merge-tag>,<br><br>Thanks for connecting us. Greatly appreciate it! Moving you to BCC to avoid spamming your inbox.<br><br>',
      },
      hasReferralSnippets: true,
      createdAt: '2024-01-22T05:49:31.894Z',
      nextState: 'continue',
      displayName: 'Not the right person',
      highlightedAt: '2024-01-22T05:49:31.919Z',
      isRoot: false,
      topicRuleId: 38,
      sequenceTouchPoints: [],
      qualificationRule: null,

      didUpdate: false,
      shouldHighlight: false,
      isContinue: true,
      isReferral: false,
      isQualified: false,
      isNotInterested: false,
      isNotInterestedNow: false,
      isTerminal: false,
      isNotTerminal: true,
      hasChildren: true,
      hasFollowUpEmail: false,
    },
  },
  {
    id: 97325,
    teamId: 1,
    updatedAt: '2024-01-22T05:49:32.651Z',
    qualificationRuleId: 33667,
    topicRule: {
      id: 6,
      teamId: null,
      ruleType: 'standard',
      nextState: 'referral',
      name: TopicRuleName.REFERRAL,
      displayName: 'Contact refers someone',
      description: 'Your contact introduces another person’s email into the thread.',
      selectable: true,
    },
    sequence: {
      id: 108040,
      teamId: 1,
      isValid: true,
      conversationTopicVersionId: 10344,
      conversationTopicVersionSettings: {},
      conversationTopicId: 5962,
      terminalState: 'referral',
      snippets: {
        referralOptIn:
          'Hi <snippet-merge-tag>{{original_lead.first_name}}</snippet-merge-tag>,<br><br>Thanks for connecting us. Greatly appreciate it!<br><br>',
        referralOptOut:
          'Hi <snippet-merge-tag>{{original_lead.first_name}}</snippet-merge-tag>,<br><br>Thanks for connecting us. Greatly appreciate it! Moving you to BCC to avoid spamming your inbox.<br><br>',
      },
      hasReferralSnippets: true,
      createdAt: '2024-01-22T05:49:32.078Z',
      nextState: 'referral',
      displayName: 'Contact refers someone',
      highlightedAt: '2024-01-22T05:49:32.089Z',
      isRoot: false,
      topicRuleId: 6,
      sequenceTouchPoints: [],
      qualificationRule: null,

      didUpdate: false,
      shouldHighlight: false,
      isContinue: false,
      isReferral: true,
      isQualified: false,
      isNotInterested: false,
      isNotInterestedNow: false,
      isTerminal: false,
      isNotTerminal: true,
      hasChildren: true,
      hasFollowUpEmail: false,
    },
  },
] as never as QualificationRuleItemSchema[];

export const MOCK_CRM_INTEGRATION: DecoratedCrmIntegrationSchema = {
  hasError: false,
  isConnected: true,
  isDisconnected: false,
  isInterrupted: false,
  isInProgress: false,
  isOk: true,
  authenticatedUserEmail: 'test@test.com',
  authenticatedUserUsername: 'username@test.com',
  connectedAt: new Date(),
  crmErrors: [],
  crmType: 'salesforce_sandbox',
  dncFieldName: 'DNC',
  id: 1,
  isAutoPushEnabled: true,
  isCrmConfigured: true,
  isFirstPackageEnabled: true,
  isSecondPackageEnabled: true,
  isCePackageEnabled: false,
  state: 'ok',
  teamId: 2,
  user: {
    createdAt: '',
    currentMembershipId: 1,
    email: 'user@test.com',
    firstName: 'John',
    id: 2,
    lastName: 'Doe',
    notifyOnBotDisconnect: false,
    title: 'marketing',
  },
  uuid: '',
  objectPermissionsEnabled: {
    account: true,
    campaignMember: true,
    campaign: true,
    contact: true,
    lead: true,
    opportunity: true,
  },
};
export const MOCK_CAMPAIGN_WORKFLOW: CampaignWorkflowSchema = {
  createdById: 1,
  createdByName: 'Jane Doe',
  id: 3,
  isActive: true,
  workflowImportStrategy: {
    crmReport: {
      crmType: 'salesforce',
      externalId: '123',
      name: 'Sample Report',
    },
  },
  workflowStat: {
    enrolledLeadsCount: 89,
    errorLeadsCount: 1,
    remainingLeadsCount: 10,
    totalLeadsCount: 100,
    updatedAt: '2022-03-16T10:04:54.269Z',
  },
};
export const AI_BLOCKS = [
  {
    defaultContent: 'hey',
    id: 1,
    teamId: 1,
  },
];
export const BOUNCE_AVOID_TIPS: { tip: string }[] = [
  { tip: 'Clean your contacts list regularly' },
  { tip: "Make sure your emails aren't spammy" },
  { tip: "Don't use free sender domains" },
  { tip: 'Use A/B testing of emails in Campaign' },
  { tip: 'Remove hard bounce email addresses from your list' },
];

export enum PotentialBounceReason {
  ROLE_BASED_EMAIL = 'roleBasedEmail',
  FREE_EMAIL_PROVIDER = 'freeEmailProvider',
  DISPOSABLE_EMAIL = 'disposableEmail',
  INVALID_EMAIL_SERVER = 'invalidEmailServer',
  INTERNAL_BOUNCE_CHECKS = 'internalBounceChecks',
}

export const POTENTIAL_BOUNCE_REASONS: {
  id: PotentialBounceReason;
  name: string;
  popupContent: string;
}[] = [
  {
    id: PotentialBounceReason.ROLE_BASED_EMAIL,
    name: 'Role-based email addresses',
    popupContent:
      'Role based email addresses are usually not associated to individuals, and might not accept any inbound emails.',
  },
  {
    id: PotentialBounceReason.FREE_EMAIL_PROVIDER,
    name: 'Personal email addresses',
    popupContent:
      'Personal emails might not be appropriate contact points, depending on the audience you would like to reach out to.',
  },
  {
    id: PotentialBounceReason.DISPOSABLE_EMAIL,
    name: 'Disposable email addresses',
    popupContent:
      'Disposable emails might self destruct in the future, and contribute to bounce rates.',
  },
  {
    id: PotentialBounceReason.INVALID_EMAIL_SERVER,
    name: 'Email server may not exist',
    popupContent:
      'Contacts might be associated with invalid domains, and any emails inbound will bounce.',
  },
];

export const MOCK_COMPANY_INFORMATION = {
  companyName: 'test name',
  companyWebsite: 'https://6sense.com',
  companyDescription: 'some description here',
  keyPersona: 'sample persona',
};

export enum BulkSelectAction {
  ALL = 'all',
  NONE = 'none',
  VISIBLE = 'visible',
}

export const MOCK_MAIN_SEQUENCE = {
  id: 120019,
  teamId: 1,
  isValid: true,
  conversationTopicVersionId: 11451,
  conversationTopicVersionSettings: {},
  conversationTopicId: 6627,
  terminalState: 'continue',
  snippets: {
    referralOptIn:
      'Hi <snippet-merge-tag>{{original_lead.first_name}}</snippet-merge-tag>,<br><br>Thanks for connecting us. Greatly appreciate it!<br><br>',
    referralOptOut:
      'Hi <snippet-merge-tag>{{original_lead.first_name}}</snippet-merge-tag>,<br><br>Thanks for connecting us. Greatly appreciate it! Moving you to BCC to avoid spamming your inbox.<br><br>',
  },
  hasReferralSnippets: true,
  createdAt: '2024-08-01T04:40:31.866Z',
  nextState: 'continue',
  displayName: 'Contact Requests for Information',
  highlightedAt: '2024-08-01T04:40:31.878Z',
  isRoot: false,
  topicRuleId: 5,
  sequenceTouchPoints: [
    {
      id: 125782,
      durationType: 'day',
      sequenceId: 120019,
      teamId: 1,
      touchPointOrder: 0,
      triggerOnDuration: 0,
      sequenceTouchPointTemplates: [
        {
          id: 126163,
          teamId: 1,
          subject: '',
          body: '<div><span style="white-space: pre-wrap;">Hi </span><merge-tag>{{lead.first_name}}</merge-tag><span style="white-space: pre-wrap;">, </span></div>',
          deliveryType: 'reply',
          snippet: 'Hi {{lead.first_name}},',
          sequenceTouchPointId: 125782,
          isActive: true,
          dynamicContents: [],
          aiBlocks: [],
          sequenceTouchPointTemplateAttachments: [],
        },
      ],
      templates: [
        {
          id: 126163,
          teamId: 1,
          subject: '',
          body: '<div><span style="white-space: pre-wrap;">Hi </span><merge-tag>{{lead.first_name}}</merge-tag><span style="white-space: pre-wrap;">, </span></div>',
          deliveryType: 'reply',
          snippet: 'Hi {{lead.first_name}},',
          sequenceTouchPointId: 125782,
          isActive: true,
          dynamicContents: [],
          aiBlocks: [],
          sequenceTouchPointTemplateAttachments: [],
          attachments: [],
        },
      ],
      isSendImmediately: true,
    },
  ],
  qualificationRule: {
    id: 36674,
    teamId: 1,
    sequenceId: 120019,
    updatedAt: '2024-08-01T04:40:31.970Z',
    conversationTopicVersionId: 11451,
    conversationTopicId: 6627,
    qualificationRuleItems: [
      {
        id: 108189,
        teamId: 1,
        updatedAt: '2024-08-01T04:40:31.916Z',
        qualificationRuleId: 36674,
        topicRule: {
          id: 1,
          teamId: null,
          ruleType: 'standard',
          nextState: 'qualified',
          name: 'Qualified Positive Intent (Goal Conversion)',
          displayName: 'Contact is Qualified',
          description: '',
          selectable: false,
        },
        sequence: {
          id: 120020,
          teamId: 1,
          isValid: true,
          conversationTopicVersionId: 11451,
          conversationTopicVersionSettings: {},
          conversationTopicId: 6627,
          terminalState: 'qualified',
          snippets: {
            referralOptIn:
              'Hi <snippet-merge-tag>{{original_lead.first_name}}</snippet-merge-tag>,<br><br>Thanks for connecting us. Greatly appreciate it!<br><br>',
            referralOptOut:
              'Hi <snippet-merge-tag>{{original_lead.first_name}}</snippet-merge-tag>,<br><br>Thanks for connecting us. Greatly appreciate it! Moving you to BCC to avoid spamming your inbox.<br><br>',
          },
          hasReferralSnippets: true,
          createdAt: '2024-08-01T04:40:31.895Z',
          nextState: 'qualified',
          displayName: 'Contact is Qualified',
          highlightedAt: '2024-08-01T04:40:31.907Z',
          isRoot: false,
          topicRuleId: 1,
          sequenceTouchPoints: [
            {
              id: 125783,
              durationType: 'day',
              sequenceId: 120020,
              teamId: 1,
              touchPointOrder: 0,
              triggerOnDuration: 0,
              sequenceTouchPointTemplates: [
                {
                  id: 126164,
                  teamId: 1,
                  subject: '',
                  body: '<div>Hi <merge-tag>{{lead.first_name}}</merge-tag>, </div>',
                  deliveryType: 'reply',
                  snippet: 'Hi {{lead.first_name}},',
                  sequenceTouchPointId: 125783,
                  isActive: true,
                  dynamicContents: [],
                  aiBlocks: [],
                  sequenceTouchPointTemplateAttachments: [],
                },
              ],
              templates: [
                {
                  id: 126164,
                  teamId: 1,
                  subject: '',
                  body: '<div>Hi <merge-tag>{{lead.first_name}}</merge-tag>, </div>',
                  deliveryType: 'reply',
                  snippet: 'Hi {{lead.first_name}},',
                  sequenceTouchPointId: 125783,
                  isActive: true,
                  dynamicContents: [],
                  aiBlocks: [],
                  sequenceTouchPointTemplateAttachments: [],
                  attachments: [],
                },
              ],
              isSendImmediately: true,
            },
          ],
          qualificationRule: null,
          didUpdate: false,
          shouldHighlight: false,
          isContinue: false,
          isReferral: false,
          isQualified: true,
          isNotInterested: false,
          isNotInterestedNow: false,
          isTerminal: true,
          isNotTerminal: false,
          hasChildren: false,
          hasFollowUpEmail: false,
        },
      },
      {
        id: 108190,
        teamId: 1,
        updatedAt: '2024-08-01T04:40:31.943Z',
        qualificationRuleId: 36674,
        topicRule: {
          id: 2,
          teamId: null,
          ruleType: 'standard',
          nextState: 'not_interested',
          name: 'Negative Intent',
          displayName: 'Contact is Not Interested',
          description: '',
          selectable: false,
        },
        sequence: {
          id: 120021,
          teamId: 1,
          isValid: true,
          conversationTopicVersionId: 11451,
          conversationTopicVersionSettings: {},
          conversationTopicId: 6627,
          terminalState: 'not_interested',
          snippets: {
            referralOptIn:
              'Hi <snippet-merge-tag>{{original_lead.first_name}}</snippet-merge-tag>,<br><br>Thanks for connecting us. Greatly appreciate it!<br><br>',
            referralOptOut:
              'Hi <snippet-merge-tag>{{original_lead.first_name}}</snippet-merge-tag>,<br><br>Thanks for connecting us. Greatly appreciate it! Moving you to BCC to avoid spamming your inbox.<br><br>',
          },
          hasReferralSnippets: true,
          createdAt: '2024-08-01T04:40:31.921Z',
          nextState: 'not_interested',
          displayName: 'Contact is Not Interested',
          highlightedAt: '2024-08-01T04:40:31.934Z',
          isRoot: false,
          topicRuleId: 2,
          sequenceTouchPoints: [
            {
              id: 125784,
              durationType: 'day',
              sequenceId: 120021,
              teamId: 1,
              touchPointOrder: 0,
              triggerOnDuration: 0,
              sequenceTouchPointTemplates: [
                {
                  id: 126165,
                  teamId: 1,
                  subject: '',
                  body: '<div>Hi <merge-tag>{{lead.first_name}}</merge-tag>, </div>',
                  deliveryType: 'reply',
                  snippet: 'Hi {{lead.first_name}},',
                  sequenceTouchPointId: 125784,
                  isActive: true,
                  dynamicContents: [],
                  aiBlocks: [],
                  sequenceTouchPointTemplateAttachments: [],
                },
              ],
              templates: [
                {
                  id: 126165,
                  teamId: 1,
                  subject: '',
                  body: '<div>Hi <merge-tag>{{lead.first_name}}</merge-tag>, </div>',
                  deliveryType: 'reply',
                  snippet: 'Hi {{lead.first_name}},',
                  sequenceTouchPointId: 125784,
                  isActive: true,
                  dynamicContents: [],
                  aiBlocks: [],
                  sequenceTouchPointTemplateAttachments: [],
                  attachments: [],
                },
              ],
              isSendImmediately: true,
            },
          ],
          qualificationRule: null,
          didUpdate: false,
          shouldHighlight: false,
          isContinue: false,
          isReferral: false,
          isQualified: false,
          isNotInterested: true,
          isNotInterestedNow: false,
          isTerminal: true,
          isNotTerminal: false,
          hasChildren: false,
          hasFollowUpEmail: false,
        },
      },
      {
        id: 108191,
        teamId: 1,
        updatedAt: '2024-08-01T04:40:31.968Z',
        qualificationRuleId: 36674,
        topicRule: {
          id: 47,
          teamId: null,
          ruleType: 'standard',
          nextState: 'not_interested_now',
          name: 'Not Interested Now',
          displayName: 'Contact is Not Interested Now',
          description:
            'Your contact is not interested now but is open for re-engagement in the future.',
          selectable: false,
        },
        sequence: {
          id: 120022,
          teamId: 1,
          isValid: true,
          conversationTopicVersionId: 11451,
          conversationTopicVersionSettings: {},
          conversationTopicId: 6627,
          terminalState: 'not_interested_now',
          snippets: {
            referralOptIn:
              'Hi <snippet-merge-tag>{{original_lead.first_name}}</snippet-merge-tag>,<br><br>Thanks for connecting us. Greatly appreciate it!<br><br>',
            referralOptOut:
              'Hi <snippet-merge-tag>{{original_lead.first_name}}</snippet-merge-tag>,<br><br>Thanks for connecting us. Greatly appreciate it! Moving you to BCC to avoid spamming your inbox.<br><br>',
          },
          hasReferralSnippets: true,
          createdAt: '2024-08-01T04:40:31.948Z',
          nextState: 'not_interested_now',
          displayName: 'Contact is Not Interested Now',
          highlightedAt: '2024-08-01T04:40:31.960Z',
          isRoot: false,
          topicRuleId: 47,
          sequenceTouchPoints: [
            {
              id: 125785,
              durationType: 'day',
              sequenceId: 120022,
              teamId: 1,
              touchPointOrder: 0,
              triggerOnDuration: 0,
              sequenceTouchPointTemplates: [
                {
                  id: 126166,
                  teamId: 1,
                  subject: '',
                  body: '<div>Hi <merge-tag>{{lead.first_name}}</merge-tag>, </div>',
                  deliveryType: 'reply',
                  snippet: 'Hi {{lead.first_name}},',
                  sequenceTouchPointId: 125785,
                  isActive: true,
                  dynamicContents: [],
                  aiBlocks: [],
                  sequenceTouchPointTemplateAttachments: [],
                },
              ],
              templates: [
                {
                  id: 126166,
                  teamId: 1,
                  subject: '',
                  body: '<div>Hi <merge-tag>{{lead.first_name}}</merge-tag>, </div>',
                  deliveryType: 'reply',
                  snippet: 'Hi {{lead.first_name}},',
                  sequenceTouchPointId: 125785,
                  isActive: true,
                  dynamicContents: [],
                  aiBlocks: [],
                  sequenceTouchPointTemplateAttachments: [],
                  attachments: [],
                },
              ],
              isSendImmediately: true,
            },
          ],
          qualificationRule: null,
          didUpdate: false,
          shouldHighlight: false,
          isContinue: false,
          isReferral: false,
          isQualified: false,
          isNotInterested: false,
          isNotInterestedNow: true,
          isTerminal: true,
          isNotTerminal: false,
          hasChildren: false,
          hasFollowUpEmail: false,
        },
      },
    ],
  },
  didUpdate: false,
  shouldHighlight: false,
  isContinue: true,
  isReferral: false,
  isQualified: false,
  isNotInterested: false,
  isNotInterestedNow: false,
  isTerminal: false,
  isNotTerminal: true,
  hasChildren: true,
  hasFollowUpEmail: false,
};

export const MOCK_TOPIC_RULES = [
  {
    id: 47,
    teamId: null,
    ruleType: 'standard',
    nextState: 'not_interested_now',
    name: 'Not Interested Now',
    displayName: 'Contact is Not Interested Now',
    description: 'Your contact is not interested now but is open for re-engagement in the future.',
    selectable: false,
  },
  {
    id: 5,
    teamId: null,
    ruleType: 'standard',
    nextState: 'continue',
    name: 'Request For Information (Generic)',
    displayName: 'Contact Requests for Information',
    description: 'Your contact asks for more details about your product or service.',
    selectable: true,
  },
  {
    id: 6,
    teamId: null,
    ruleType: 'standard',
    nextState: 'referral',
    name: 'Referral',
    displayName: 'Contact Refers Someone',
    description: 'Your contact introduces another person’s email into the thread.',
    selectable: true,
  },
];

export const MAX_ALT_TEXT_COUNT = 200;

export const REWRITE_LOADING_STEPS = [
  {
    title: 'Checking playbook...',
    progress: 0,
  },
  {
    title: 'Extracting relevant information...',
    progress: 30,
  },
  {
    title: 'Analyzing data...',
    progress: 45,
  },
  {
    title: 'Strategizing...',
    progress: 60,
  },
  {
    title: 'Wordsmithing...',
    progress: 75,
  },
  {
    title: 'Some final checks...',
    progress: 90,
  },
];

export const FALLBACK_BOT = {
  id: -1,
  email: 'dolores@saleswhale.com',
  emailProvider: 'gmail',
  name: 'Dolores Ng',
  picture: '',
  createdAt: '2023-08-14T08:53:20.823Z',
  outreachEmailsSentToday: 0,
  paused: false,
  timeZone: 'Asia/Shanghai',
  signature: '',
  state: 'connected',
  useUnsubscribe: true,
  unsubscribeText:
    '<small><div><span style="white-space: pre-wrap;">To unsubscribe, </span><span style="white-space: pre-wrap;">click</span><span style="white-space: pre-wrap;"> </span><a href="https://engage.dev3.conversations.6si.com/api/v1/unsubscribes" rel="noreferrer"><span style="white-space: pre-wrap;">here</span></a><span style="white-space: pre-wrap;">. </span></div></small>',
} as BotSchema;

export const SENDGRID_GENERIC_KB_ARTICLE_LINK =
  'https://support.6sense.com/knowledge-base/internal-only-integrating-sendgrid-with-6sense-conversational-email/';
export const SENDGRID_ERROR_KB_ARTICLE_LINK =
  'https://support.6sense.com/knowledge-base/internal-only-conversational-email-sendgrid-integration-troubleshooting-guide/';

export const EMPTY_AI_TONE_INPUT: AiToneInput = { customInstructions: null, formality: 'neutral' };

export const DD_IGNORED_MESSAGES = [
  'ResizeObserver loop',
  'Unexpected error occurred. Please contact Saleswhale support with the error reference code',
  'Network request failed',
  'Token is invalid',
  'Token is expired',
  'Unauthorized',
  'Script error.',
  'AbortError: Aborted',
  'Object Not Found Matching Id',
];

export const DATE_QUERY_PARAM_FORMAT = 'yyyy-MM-dd';

export const BOUNCE_REASON_MESSAGE =
  'Bounce reason is available for campaigns starting on or after 13th April 24.';

export const IGNORED_ATTRIBUTE_STRING = '%%IGNORED_ATTRIBUTE%%';

export const SIXSENSE_INBOX_DISPLAY_NAME = '6sense';

export const WARMUP_INFO = [
  {
    warmUpStatus: 'new',
    age: '0-10 days old',
    emailsSent: '--',
    bounceRate: '--',
  },
  {
    warmUpStatus: 'healthy',
    age: 'At least 11 days old',
    emailsSent: '--',
    bounceRate: 'Less than 3%',
  },
  {
    warmUpStatus: 'caution',
    age: 'At least 11 days old',
    emailsSent: 'Less than 1000',
    bounceRate: '3-5%',
  },
  {
    warmUpStatus: 'critical',
    age: 'At least 11 days old',
    emailsSent: 'Less than 1000',
    bounceRate: 'More than 5%',
  },
];

export const DEFAULT_AI_BLOCKS_PER_TOUCHPOINT = [3, 2, 2];

export const SHOW_AI_BLOCK_EXPLAINER_KEY = 'show_ai_block_explainer';
export const HIDE_QUICK_START_GUIDE_KEY = 'hide_quick_start_guide';

export const EMPTY_AI_WRITER: AiWriterSchema = {
  companyDescription: '',
  companyName: '',
  companyWebsite: '',
  id: '',
  keyPersona: '',
  sixSenseKeywords: [],
};

/** HIDDEN_CAMPAIGN_PLAYBOOK_IDS - Product wants to remove
 * these playbooks but we shouldn't delete them from the BE
 * since campaigns might be linked to them already */
export const HIDDEN_CAMPAIGN_PLAYBOOK_IDS = ['7', '3'];

export const ACTIVE_BOTS_PER_PAGE = 100;

export const EMAIL_BOUNCE_RISK_OPTIONS = [
  {
    label: 'Low risk emails (up to 10%)',
    value: 'A+',
    subLabel:
      'Ideal for reputation-sensitive campaigns. However, may significantly reduce campaign reach.',
  },
  {
    label: 'Moderate risk emails (up to 15%)',
    value: 'A',
    subLabel:
      'Recommended for most campaigns. Offers best balance between higher campaign reach and lower bounce risk.',
  },
  {
    label: 'High risk emails (up to 20%)',
    value: 'B+',
    subLabel:
      'Risky for large and reputation-sensitive campaigns. May increase campaign reach as well as bounce risk.',
  },
  {
    label: 'All emails',
    value: 'B',
    subLabel:
      'Auto-enroll all emails, regardless of their predicted bounce risk. Maximizes campaign reach at the cost of higher bounce risk.',
  },
];

export const EMAIL_GRADE_COPY: Record<EmailGrade, string> = {
  'A+': '0%-10%',
  A: '10%-15%',
  'B+': '15%-20%',
  B: 'Over 20%',
};

export const EMPTY_CUSTOM_INTENT: CustomIntentSchema = {
  name: '',
  callToAction: 'continue_conversation',
  description: '',
  replyStrategy: '',
  baseIntent: null,
  actions: [
    { conversationStatus: { mode: 'end_with_status', result: 'qualified' }, enabled: true },
  ],
};

export const CUSTOM_INTENT_RESULT_OPTIONS: {
  key: CustomIntentConversationStatus;
  text: string;
  value: CustomIntentConversationStatus;
}[] = [
  { value: 'qualified', key: 'qualified', text: 'Qualified' },
  { value: 'not_interested', key: 'not_interested', text: 'Not interested' },
  { value: 'not_interested_now', key: 'not_interested_now', text: 'Not interested now' },
];

export const CUSTOM_INTENT_BASE_INTENTS = [
  {
    baseIntent: CustomIntentBaseIntent.QUALIFIED,
    description: 'Lead requests for a meeting or a call, lead expresses positive intent',
    topicRuleName: TopicRuleName.QUALIFIED,
    name: 'Contact is qualified',
    classification: [
      DefaultIntentClassification.POSITIVE,
      DefaultIntentClassification.QUALIFIED,
      DefaultIntentClassification.QUALIFIED_POSITIVE,
    ],
  },
  {
    baseIntent: CustomIntentBaseIntent.NOT_INTERESTED,
    description: 'Lead expresses negative intent',
    topicRuleName: TopicRuleName.NOT_INTERESTED,
    name: 'Contact is not interested',
    classification: [DefaultIntentClassification.NEGATIVE],
  },
  {
    baseIntent: CustomIntentBaseIntent.NOT_INTERESTED_NOW,
    description: 'Lead expresses negative intent with an opening for future engagement',
    topicRuleName: TopicRuleName.NOT_INTERESTED_NOW,
    name: 'Contact is not interested now',
    classification: [DefaultIntentClassification.NIN],
  },
  {
    baseIntent: CustomIntentBaseIntent.NOT_RIGHT_PERSON,
    description: 'Lead mentions they are not the right contact or department',
    topicRuleName: TopicRuleName.NOT_RIGHT_PERSON,
    name: 'Contact is not the right person',
    classification: [DefaultIntentClassification.NTRP],
  },
  {
    baseIntent: CustomIntentBaseIntent.REFERRAL,
    description: 'Lead introduces another person into the conversation',
    topicRuleName: TopicRuleName.REFERRAL,
    name: 'Contact refers someone',
    classification: [DefaultIntentClassification.REFERRAL],
  },
];
export const MOCK_CUSTOM_INTENT_TEMPLATES: CustomIntentSchema[] = [
  {
    id: 1,
    baseIntent: null,
    name: 'Contact asks for pricing',
    callToAction: 'cc_sales_rep',
    description: 'When contact asks for or about pricing',
    replyStrategy: 'Send them to company website',
    actions: [
      { conversationStatus: { mode: 'end_with_status', result: 'qualified' }, enabled: true },
      { ccSalesReps: { mode: 'default' }, enabled: true },
    ],
  },
  {
    id: 2,
    baseIntent: null,
    name: 'Contact asks for link',
    callToAction: 'cc_sales_rep',
    description: 'When contact asks for the webinar link',
    replyStrategy: 'Send them to company website',
    actions: [{ conversationStatus: { mode: 'continue' }, enabled: true }],
  },
];

export const QUALIFIED_BASE_INTENT_ACTIONS: CustomIntentAction[] = [
  { ccSalesReps: { mode: 'default' }, enabled: true },
  { conversationStatus: { mode: 'end_with_status', result: 'qualified' }, enabled: true },
];

export const TEAM_ID_TO_6SENSE_ORG_NAME: Record<number, string> = {
  158: 'randstad',
  162: 'randstad',
  167: 'randstad',
  269: 'hcltechsw',
  270: 'hcltechsw',
  291: 'cisco',
  322: 'sandboxmentorcliq',
  323: 'hcltechsw',
  408: 'randstad',
  476: 'theaccessgroup',
  525: 'btl',
  533: 'hays',
  614: 'hcltechsw',
  621: 'hcltechbfsi',
  622: 'hcltechsw',
  623: 'hcltechsw',
  632: 'anaplan',
  639: 'aflac',
  645: 'hcltechsw',
  680: 'randstad',
  806: 'hcltechsw',
  864: 'goldenstatewarriors',
  883: 'checkout',
  900: 'wipro',
  929: 'launchdarkly',
  980: 'nationalgallery',
  1041: 'workdaynew1',
  1115: 'leadfabric',
  1149: 'procurementiq',
  1150: 'procurementiq',
  1151: 'procurementiq',
  1152: 'procurementiq',
  1155: 'aptean',
  1161: 'frontapp',
  1169: 'insightpartners',
  1232: 'greenhat',
  1242: 'bigcommerce',
  1251: 'perimeter81',
  1258: 'vonage',
  1261: 'netskope',
  1262: 'udacity',
  1310: 'hcltechbfsi',
  1311: 'hcltechsw',
  1367: 'hcltechsw',
  1388: 'pearson',
  1395: 'hcltechsw',
  1443: 'bigid',
};
